define('anaAssayDetailView',[
  'module',
  'anaAssayCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!anaAssayDetailTabTpl',
  'settings'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  Settings
) {
  'use strict';

  var AnaAssayDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.currentCAccountSecId = Settings.get('currentCAccount').secId;
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        anaAssayModel: this.model
      });
      createEditView.show({
        title: _.i18n('anaassay.edit')
      });
    }

  });

  module.exports = AnaAssayDetailView;
});
